import React from "react";

type OrderRowProps = {
  label: string;
  value: React.ReactNode;
};

export const OrderRow: React.FC<OrderRowProps> = ({ label, value }) => (
  <div className="row">
    <span className="label">{label}:</span>
    <span className="value">{value}</span>
  </div>
);
